var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotions && _vm.promotions.length)?_c('Term',{attrs:{"small":_vm.small,"term":_vm.setTerm()}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }